import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GenericValue } from 'hisng';
import { Classifications } from '../../../model/classifications';

@Component({
    selector: 'psv-personprofile-edit-classifications',
    templateUrl: './personprofile-edit-classifications.component.html',
    standalone: false
})
export class PersonProfileEditClassificationsComponent {
    @Input() header: string;
    @Input() classifications: Classifications;
    @Input() researchAreaDdKey: string;
    @Input() subjectAreaDdKey: string;
    @Input() researchAreaKdsfDdKey: string;

    public onSelectedResearchAreasKdsfChange($event: GenericValue[]) {
        this.classifications.researchAreasKdsf = $event;
    }
    
    public onSelectedResearchAreasChange($event: GenericValue[]) {
        this.classifications.researchAreas = $event;
    }
    
    public onSelectedSubjectAreasChange($event: GenericValue[]) {
        this.classifications.subjectAreas = $event;
    }
}
